const CATEGORY_STYLES = {
  BANK_FEES: {
    icon: "account_balance_wallet",
    primary: "#7A2E2E",
    text: "#5A1717",
    background: "#FFF0F0",
    border: "#FFB8B8",
  },
  ENTERTAINMENT: {
    icon: "confirmation_number",
    primary: "#0037EB",
    text: "#001B75",
    background: "#EBEFFF",
    border: "#A8BDFF",
  },
  FOOD_AND_DRINK: {
    icon: "restaurant",
    primary: "#C05600",
    text: "#7A3500",
    background: "#FFF3E6",
    border: "#FFC785",
  },
  GENERAL_MERCHANDISE: {
    icon: "shopping_bag",
    primary: "#005A9E",
    text: "#00365F",
    background: "#EAF5FF",
    border: "#9ED1FF",
  },
  GENERAL_SERVICES: {
    icon: "handyman",
    primary: "#00796B",
    text: "#004D43",
    background: "#E6F7F4",
    border: "#9EDBD2",
  },
  GOVERNMENT_AND_NON_PROFIT: {
    icon: "account_balance",
    primary: "#5D3B8C",
    text: "#3A235B",
    background: "#F2ECFF",
    border: "#C8B5F6",
  },
  HOME_IMPROVEMENT: {
    icon: "home_repair_service",
    primary: "#647A00",
    text: "#405000",
    background: "#F5F9DF",
    border: "#D4E47A",
  },
  INCOME: {
    icon: "payments",
    primary: "#2E7D32",
    text: "#1B5E20",
    background: "#EAF7EA",
    border: "#A8DDA8",
  },
  LOAN_PAYMENTS: {
    icon: "account_balance",
    primary: "#667085",
    text: "#40464B",
    background: "#F2F4F7",
    border: "#D0D5DD",
  },
  MEDICAL: {
    icon: "medical_services",
    primary: "#C62828",
    text: "#7F1D1D",
    background: "#FFECEC",
    border: "#FFB4B4",
  },
  OTHER: {
    icon: "category",
    primary: "#666B6F",
    text: "#40464B",
    background: "#F7F8F8",
    border: "#D4D5D6",
  },
  PERSONAL_CARE: {
    icon: "self_care",
    primary: "#9C27B0",
    text: "#5F156B",
    background: "#FBEAFC",
    border: "#E2A8EA",
  },
  RENT_AND_UTILITIES: {
    icon: "receipt_long",
    primary: "#AD1457",
    text: "#6D0E38",
    background: "#FFF0F6",
    border: "#F5A9CB",
  },
  BILLS: {
    icon: "receipt_long",
    primary: "#AD1457",
    text: "#6D0E38",
    background: "#FFF0F6",
    border: "#F5A9CB",
  },
  CREDIT_CARD: {
    icon: "credit_card",
    primary: "#9A5B00",
    text: "#6B3D00",
    background: "#FFF4E6",
    border: "#E8C28A",
  },
  TRANSFER_IN: {
    icon: "swap_horiz",
    primary: "#2F6F8F",
    text: "#1F4A60",
    background: "#EAF6FB",
    border: "#A6D4E8",
  },
  TRANSFER_OUT: {
    icon: "swap_horiz",
    primary: "#2F6F8F",
    text: "#1F4A60",
    background: "#EAF6FB",
    border: "#A6D4E8",
  },
  TRANSPORTATION: {
    icon: "directions_car",
    primary: "#0077A8",
    text: "#004C6C",
    background: "#E7F7FF",
    border: "#95D7F2",
  },
  TRAVEL: {
    icon: "luggage",
    primary: "#4B7F16",
    text: "#31540E",
    background: "#F1FAE8",
    border: "#B9DF8A",
  },
};

const DEFAULT_CATEGORY_STYLE = CATEGORY_STYLES.OTHER;

const CATEGORY_STYLE_ALIASES = {
  BANK_PENALTIES: "BANK_FEES",
  CHILDCARE_AND_EDUCATION: "GENERAL_SERVICES",
  DINING: "FOOD_AND_DRINK",
  FOOD_RETAIL: "FOOD_AND_DRINK",
  GOVERNMENTS_AND_NON_PROFIT: "GOVERNMENT_AND_NON_PROFIT",
  INSURANCE_AND_TAX: "GENERAL_SERVICES",
  INTEREST_PAYMENTS: "BANK_FEES",
  INTERESTS_AND_DIVIDENDS: "INCOME",
  LOAN_DISBURSEMENTS: "LOAN_PAYMENTS",
  PET_CARE_AND_SUPPLIES: "PERSONAL_CARE",
  TAX_REFUND: "INCOME",
  TRAVEL_AND_TRANSPORTATION: "TRANSPORTATION",
  UNKNOWN: "OTHER",
};

const normalizeCategoryCode = (categoryCode, label) => {
  const source = categoryCode || label || "OTHER";

  return String(source)
    .trim()
    .replace(/&/g, " AND ")
    .replace(/-/g, " ")
    .replace(/\s+/g, "_")
    .toUpperCase();
};

const getStyleKey = (code) => {
  if (!code) return null;

  const normalizedCode = normalizeCategoryCode(code);
  const aliasedCode = CATEGORY_STYLE_ALIASES[normalizedCode] || normalizedCode;

  if (CATEGORY_STYLES[aliasedCode]) {
    return aliasedCode;
  }

  const matchingCode = Object.keys({
    ...CATEGORY_STYLES,
    ...CATEGORY_STYLE_ALIASES,
  }).find(
    (styleKey) => normalizedCode.startsWith(`${styleKey}_`),
  );

  return CATEGORY_STYLE_ALIASES[matchingCode] || matchingCode;
};

function CategoryPill({
  label,
  categoryCode,
  categoryPrimary,
  categoryDetailed,
}) {
  const styleKey =
    getStyleKey(categoryPrimary) ||
    getStyleKey(categoryCode) ||
    getStyleKey(categoryDetailed) ||
    getStyleKey(label);
  const style = CATEGORY_STYLES[styleKey] || DEFAULT_CATEGORY_STYLE;
  const displayLabel = label || "Other";

  return (
    <span
      className="category-pill"
      style={{
        color: style.text,
        background: style.background,
        borderColor: style.border,
      }}
      title={displayLabel}
    >
      <span
        className="category-pill-icon mFont"
        style={{ color: style.primary }}
      >
        {style.icon}
      </span>
      <span className="category-pill-label">{displayLabel}</span>
    </span>
  );
}

export default CategoryPill;
